<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser"></left-panel>
        </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <grid-row class="justify-content-center align-content-between pb-30 h-100">
                <grid-col col="12">
                    <grid-row >
                        <grid-col col="8">
                            <div class="font-400 font-size-20px line-h-25">
                                {{ "UploadDocumentsBelow" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                    
                </grid-col>
                <grid-col col="12" *ngFor="let d of this.docs; let i = index;">
                    <div class="mt-30">
                        <attach-box [disabled]="true" heading="{{d.labelEn}}" id="{{d.docId}}" text="{{d.descriptionEn}}" [imageName]="d.name != undefined ? d.name: d.name" (returnImageName)="Uploaddoc($event,d,i)"></attach-box>
                    </div>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between align-item-center mt-50">
                        <grid-col col="auto">
                            <div class="mt-15">
                                <button class="btn-back" (click)="back()">
                                    <i class="icon-back"></i>
                                </button>
                            </div>
                        </grid-col>
                        <grid-col col="9">
                            <!-- <button class="btn-dft" (click)="showModal(2)">
                                        {{ "NEXT" | translate }}
                                    </button> -->
                            <button class="btn-dft" [disabled]="this.DocList.length == 0  || this.docs.length  &gt; this.DocList.length" (click)="SaveLimitDoocs()">
                                {{ "NEXT" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>


        </div>
    </div>
</div>


<!-- OTP Modal -->
<modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    (doneButton)="cardLimitSuccess()">
    <grid-row class="justify-content-center">
        <grid-col col="6">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <span class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter4digit" | translate }}
                    </span>
                    <span class="color-primary font-size-20px font-400 line-h-25">
                        ••• •••• 8888
                    </span>
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)" allowNumbersOnly='true'
            [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
        <!-- <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp"> -->
    </div>
    <grid-row class="justify-content-between align-item-center mt-50">
        <grid-col col="auto">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="link font-600 font-size-12px color-primary">
                {{ "ChangeMobileNumber" | translate }}
            </div>
        </grid-col>
    </grid-row>
</modal>